import axios from 'axios';

export const xios = axios.create({
  // baseURL: 'http://localhost:7757',
  baseURL: 'https://api.igeotechgps.com',
});
